var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"left !important"}},[_c('VueApexCharts',{ref:"vchart",attrs:{"type":_vm.type,"height":"295","options":_vm.chartOptions,"series":_vm.downloadedSeries}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }